const Flickity = require('flickity');
require('flickity-imagesloaded');
require('lazysizes');

export default {
    featuredInsightSlider() {
        this.gallery = new Flickity('.slider.featured-insight-slider', {
            cellSelector: ".slider__slide",
            cellAlign: "left",
            adaptiveHeight: true,
            contain: true,
            imagesLoaded: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            arrowShape: "M 0,50 L 1,47.5 L 32,23 L 35,24 L 35,27 L 10,47 L 99,47 L 100,50 L 99,53 L 10,53 L 35,73 L 35,76 L 32,77 L 1,52.5 Z",
            on: {
                ready: function () {
                    // function resizeHelper(){
                    //   let padding = $('.sec').not('.sec--insight-feature').find('.sec__inner').offset().left;
                    //   $('.listing--insight-feature').css('padding-left', padding);
                    //   $('.featured-insight-slider').find('.flickity-page-dots').css('left', padding);
                    // }
                    // resizeHelper();
                    // $(window).on('resize', resizeHelper);
                }
            }
        });
    },

    init() {
        const self = this;
        if ($('.slider.featured-insight-slider').length) {
            this.featuredInsightSlider();
        }

        const params = new URLSearchParams(window.location.search);

        let isNewFilter = false;

        function updateLoadMoreButton() {
            const $btn = $('.load-more-btn');

            if ($('.pagination-flag').length) {
                $btn.show();
                $btn.data('page', $('.pagination-flag').data('next'));

                $btn.off('click').on('click', function (e) {
                    e.preventDefault();
                    isNewFilter = false;
                    params.set('page', $(this).data('page'));
                    queryInsights();
                });
            } else {
                $btn.hide();
            }
        }

        function updateFeatureGallery(paramString) {
            let scrollOffset = 0;
            if (paramString != '?collection=publications') {
                $('.featured-insight-slider').hide();
                if (self.gallery) {
                    self.gallery.resize()
                }
                let $filterBar = $('#insight-filter-bar');
                scrollOffset = $filterBar.length ? $filterBar.offset().top : 0;
            } else {
                $('.featured-insight-slider').show();
                if (self.gallery) {
                    self.gallery.resize();
                }
                let $filterBar = $('.featured-insight-slider');
                scrollOffset = $filterBar.length ? $filterBar.offset().top : 0;
            }

            // only scroll if this is the first page
            if (!params.get('page')) {
                $('html,body').animate({
                    scrollTop: scrollOffset
                }, 800);
            }

        }


        // this will need to be called again with the new html
        function addFilterBarEventHandlers() {
            $('[data-js="remove-publications"]').off('click').on('click', function (e) {
                e.preventDefault();

                let $elem = $(this);
                let $form = $($elem.attr('data-form'));
                let value = $elem.attr('data-value');
                let $target = $form.find(`[value=${value}]`);

                // if the "publications" filter is removed 
                // we will just return to the main insight page
                if ($elem.attr('data-target') == 'collection') {
                    window.location.href = '/insights/';
                }
                if ($elem.attr('data-target') == 'tab') {
                    // window.location.href = '/insights/';
                    $('[data-tab="*"]').trigger('click');
                }

                $target.parent().trigger('click');
                $form.find('.submit-filters').click();
            });
        }

        addFilterBarEventHandlers();

        function updateFilterBar(paramString) {

            // putting this in an AJAX query is easier than 
            // re-writing the twig logic in JS to add / remove tags
            let endpoint = '/insights/filterBar' + paramString;

            let current_request = $.ajax({
                url: endpoint,
                method: 'GET',
                data: {},
                beforeSend: function () {
                    if (current_request != null) {
                        current_request.abort();
                    }
                }
            }).always(function () {
            }).done(function (data) {
                $('#insight-filter-bar').html(data);
                addFilterBarEventHandlers();
            });
        }

        function queryInsights(passedParams) {
            let paramString = passedParams ? passedParams : '?' + params.toString();
            // endpoint to hit for craft content
            let api_endpoint = '/insights/pagination' + paramString;
            // used to update the URL of the page for users
            let url_endpoint = '/insights/' + paramString;

            history.pushState({}, document.title, url_endpoint);

            let current_request = $.ajax({
                url: api_endpoint,
                method: 'GET',
                data: {},
                beforeSend: function () {
                    if (current_request != null) {
                        current_request.abort();
                    }
                    $('.insight-list').addClass('is-loading');
                    updateFeatureGallery(paramString);
                }
            }).always(function () {
                $('.insight-list').removeClass('is-loading');
            }).done(function (data) {
                // check if this is a new list or a continued list
                $('.pagination-flag').remove();

                if (isNewFilter) {
                    $('.insight-list').html(data);
                } else {
                    $('.insight-list').append(data);
                }

                updateFilterBar(paramString);
                updateLoadMoreButton();
            });
        }

        window.addEventListener('popstate', function (event) {
            queryInsights();
        });

        // we will need to do this on initial load
        updateLoadMoreButton();

        if (self.gallery) {
            if (params.get('tab')) {
                $(`.publication-tab`).removeClass('is-selected');
                $(`.publication-tab[data-tab="${params.get('tab')}"]`).addClass('is-selected');
                $('.featured-insight-slider').hide();
                self.gallery.resize();
            } else {
                $('.featured-insight-slider').show();
                self.gallery.resize();
            }
        }

        $('.publication-tab').on('click', function () {
            let tab = $(this).data('tab');
            $('.publication-tab').removeClass('is-selected');
            $(this).addClass('is-selected');

            if (tab && tab != "*") {
                params.set('tab', tab);
                $('.featured-insight-slider').hide();
                self.gallery.resize();
            } else {
                params.delete('tab');
                $('.featured-insight-slider').show();
                self.gallery.resize();
                self.featuredInsightSlider();
            }
            params.delete('page');
            isNewFilter = true;
            queryInsights(buildQueryStr());
        });

        function checkOptions(search) {
            let $options = $(search);
            let $checked = $options.filter(':checked');
            if ($options.length >= $checked.length) {
                return $checked.map(function (i, el) {
                    return $(el).val();
                }).get().join(',');
            }
        }


        function buildQueryStr() {
            const collection = params.get('collection');
            const tab = params.get('tab');
            const page = params.get('page');
            let string = '';
            let yearOptions = checkOptions('[name="release-year"]');
            let typeOptions = checkOptions('[name="type"]');
            let editionOptions = checkOptions('[name="edition"]');

            if (collection) {
                string += '?collection=' + collection;
            }
            if (tab) {
                string += '&tab=' + tab;
            }
            if (page) {
                string += '&page=' + page;
            }
            if (yearOptions) {
                params.set('release-year', yearOptions);
                string += '&release-year=' + yearOptions;
            } else {
                params.delete('release-year');
            }
            if (typeOptions) {
                params.set('type', typeOptions);
                string += '&type=' + typeOptions;
            } else {
                params.delete('type');
            }
            if (editionOptions) {
                params.set('edition', editionOptions);
                string += '&edition=' + editionOptions;
            } else {
                params.delete('edition');
            }
            return string;
        }

        $('#modal-publications-filters .submit-filters').on('click', function (e) {
            e.preventDefault();

            params.delete('page');
            isNewFilter = true;
            queryInsights(buildQueryStr());
            MicroModal.close('modal-publications-filters');
            MicroModal.close('modal-contact');
        });


        $('#modal-publications-filters .search__filter--option').off('click').on('click', function (e) {
            let $radio = $(this);
            let $input = $radio.find('input');

            $radio.toggleClass('active');
            $input.prop("checked", !$input.prop("checked"));
        });

        if (window.innerWidth < 768) {
            $('.search__filter--headline').on('click', function () {
                if ($(this).hasClass('is-sort')) {
                    $('.search__filter.is-sort').slideToggle();
                }
                if ($(this).hasClass('is-filters')) {
                    $('.search__filter.is-filters').slideToggle();
                }
            });
            $('.search__filter--headline').trigger('click');
        }

        // Lets use the old handler in "filters.js"
        // This will use AJAX but there are some bugs to work out

        // $('select[data-js="submit"]').on('change', function (e) {
        //     e.preventDefault();
        //     let $select = $(this);
        //     let name = $select.attr('name');
        //     let value = $select.val();
        //     if (value && value != "*") {
        //         params.set(name, value);
        //     } else {
        //         params.delete(name);
        //     }
        //     params.delete('page');
        //     isNewFilter = true;
        //     queryInsights();
        // });
    },
};
